function GetQuestionGrouping(translations) {
  const ret = [];

  translations?.Themes?.forEach(theme => {
    const val = {
      key: theme.trans_lang_program_num,
      title: theme.trans_lang_variable_text,
      questions: getQuestions(theme.trans_lang_variable_key, translations),
    };

    ret.push(val);
  });

  return ret;
}

export function getQuestions(theme, translations) {
  const ret = [];

  translations?.Question?.lang.forEach(lang => {
    if (lang.vPay?.vLangTheme === theme) {
      ret.push(lang);
    }
  });

  return ret;
}

export default GetQuestionGrouping;
